var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-grid",attrs:{"data-uk-grid":""}},[_c('div',{staticClass:"uk-width-1-1"},[_vm._v(" "+_vm._s(_vm.data.body)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }